import { useTranslation } from 'react-i18next';
import { faBoxCircleCheck } from '@fortawesome/pro-light-svg-icons';
import ActionButton from 'components/ui/ActionButton';
import styled from 'styled-components';

type CompleteBatchReturnProps = {
    onComplete: () => void;
    disabled: boolean;
    isLoading?: boolean;
};

const CompleteBatchReturn = ({ onComplete, disabled, isLoading }: CompleteBatchReturnProps) => {
    const { t } = useTranslation();
    return (
        <PrimaryStatusBtn
            label={t('completeBatchReturn', 'Complete batch return')}
            onClick={onComplete}
            disabled={disabled}
            isLoading={isLoading}
            icon={faBoxCircleCheck}
            fullWidth
            rounded
        />
    );
};

export default CompleteBatchReturn;

const PrimaryStatusBtn = styled(ActionButton)<{ disabled: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 1rem;
    border: none;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;

    background: #6fb48f !important;
    color: ${({ theme }) => theme.colors.fillWhite} !important;

    &:disabled {
        background: ${({ theme }) => theme.colors.disabled} !important;
        cursor: text;
    }

    &:not(:disabled):hover {
        opacity: 0.7;
    }
`;
